import Konva from 'konva/konva'
import VariableBase, { separator } from './variable-base'
import { linearTransform } from '../utils'

const valuesHeight = { initial: 75, minimal: 45 }
const line = { defaultColor: 'Gray', width: 3 }

export default class AnalogueVariable extends VariableBase {
  constructor ({ width, yOffset, timeFrom, timeTo, nowX, name, config, values, resizeHandleData, yScaleData, variableUserData, redraw }) {
    super()
    Object.assign(this, {
      width,
      yOffset,
      timeFrom,
      timeTo,
      nowX,
      name,
      config,
      values,
      resizeHandleData,
      yScaleData,
      variableUserData,
      redraw
    })

    this.minValue = this._findValuesBound(Math.min)
    this.maxValue = this._findValuesBound(Math.max)

    this.valuesHeight = variableUserData.valuesHeight || valuesHeight.initial
  }

  _getMinValuesHeight () {
    return valuesHeight.minimal
  }

  _getValuesHeight () {
    return this.valuesHeight
  }

  resizeHeight (diff) {
    this.variableUserData.valuesHeight = Math.max(this.valuesHeight + diff, valuesHeight.minimal)
    this.redraw()
  }

  _findValuesBound (compare) {
    return this.values.length === 0 ? null
      : this.values.reduce(
        (acc, [_, value]) => compare(acc, value),
        this.values[0][1]
      )
  }

  _valueToY (value) {
    // convert value (Y axis) to canvas Y coordinate
    const { minValue, maxValue, yOffset } = this
    return linearTransform(
      { from: minValue, to: maxValue },
      { from: separator.margin + yOffset + this.valuesHeight, to: separator.margin + yOffset }, value)
  }

  _calculateLinePoints () {
    const { values, timeTo } = this
    let prevValue
    const points = values
      .reduce((acc, [time, value]) => {
        if (prevValue !== undefined) {
          this._addPoint(acc, { time, value: prevValue })
        }
        this._addPoint(acc, { time, value })
        prevValue = value
        return acc
      }, [])
    if (values.length) { // continue the line to end
      this._addPoint(points, { time: timeTo, value: values[values.length - 1][1] })
    }
    return points
  }

  _addScale () {
    const { minValue, maxValue } = this
    this.yScaleData.push({
      type: 'analogue',
      yFrom: this._valueToY(maxValue),
      yTo: this._valueToY(minValue),
      minValue,
      maxValue
    })
  }

  render () {
    this.destroyChildren()

    this._renderBackground()
    this._renderNoData()
    this._renderSeparators()

    const color = this.config && this.config.color
    const points = this._calculateLinePoints()
    this.add(new Konva.Line({
      points,
      stroke: color || line.defaultColor,
      strokeWidth: line.width,
      lineJoin: 'round',
      tension: 0.0
    }))

    this._renderFutureRect()
    this._addScale()
    this._addResizeHandle()
  }

  getLabelAtTime (time) {
    return this._getValueAtTime(time)
  }
}
